
















import Vue, { PropType } from 'vue';

// models
import { IQuote, QuoteType } from '@/models/quote';

import QuoteProposalSummaryDetailCard from './QuoteProposalSummaryDetailCard.vue';
import QuoteSummaryDetailList from './QuoteSummaryDetailList.vue';
import QuoteVentilationSummaryDetailList from './QuoteVentilationSummaryDetailList.vue';
import QuoteSummaryTermList from './QuoteSummaryTermList.vue';

export default Vue.extend({
  name: 'QuoteDetailCard',

  components: {
    QuoteProposalSummaryDetailCard,
    QuoteSummaryDetailList,
    QuoteSummaryTermList,
    QuoteVentilationSummaryDetailList
  },
  props: {
    quote: { type: Object as PropType<IQuote> }
  }
});
